// Get Unmasking Invitations
export const GET_UNMASKING_INVITATIONS_REQUEST = 'GET_UNMASKING_INVITATIONS_REQUEST';
export const GET_UNMASKING_INVITATIONS_DONE = 'GET_UNMASKING_INVITATIONS_DONE';
export const GET_UNMASKING_INVITATIONS_FAILED = 'GET_UNMASKING_INVITATIONS_FAILED';

// Operations
export const UNMASKING_INVITATIONS_SET_PAGE = 'UNMASKING_INVITATIONS_SET_PAGE';